import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ZapIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center pt-28 pb-20 px-6 max-sm:pt-20 max-sm:pb-12 max-sm:px-4 overflow-hidden" data-id="element-268">
      {/* Background Image - Blurred */}
      <div className="absolute inset-0 bg-cover bg-top bg-no-repeat blur-[6px] scale-105" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/5dQYRQ579AbXenbn5qkhxw/FONDO_PAGINA_WEB_2.png')",
      backgroundPosition: 'center 20%'
    }} data-id="element-269" />
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-[#0A0A0A]/85" data-id="element-270" />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-16 max-sm:gap-10 items-center relative z-10" data-id="element-271">
        {/* Left Content */}
        <motion.div variants={staggerContainer} initial="hidden" animate="show" className="flex flex-col items-center max-sm:text-center md:items-start md:text-left" data-id="element-272">
          {/* Producto Premium Badge */}
          <motion.div variants={fadeUp} className="mb-4" data-id="element-273">
            <span className="text-[#D4AF37] text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-274">
              PRODUCTO PREMIUM · DESCARGA INMEDIATA
            </span>
          </motion.div>

          {/* 5 Stars */}
          <motion.div variants={fadeUp} className="flex gap-1 text-[#D4AF37] mb-6" data-id="element-275">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-276" />)}
          </motion.div>

          {/* ESTO ES PARA TI Badge */}
          <motion.div variants={fadeUp} className="inline-block mb-6 px-6 py-3 bg-gradient-to-r from-[#D4AF37]/10 to-[#B8962E]/10 border border-[#D4AF37]/50 rounded-full" data-id="element-277">
            <span className="text-[#D4AF37] font-bold text-base md:text-lg tracking-wide drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]" data-id="element-278">
              ⚡ ESTO ES PARA TI
            </span>
          </motion.div>

          <motion.h1 variants={fadeUp} className="text-3xl md:text-5xl lg:text-[3.5rem] xl:text-6xl font-serif font-bold text-[#E8E0D0] leading-[1.1] mb-6 max-sm:mb-5" data-id="element-279">
            Esto es lo que estabas{' '}
            <span className="text-[#D4AF37] italic drop-shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-280">
              NECESITANDO.
            </span>
          </motion.h1>

          <motion.p variants={fadeUp} className="text-xl md:text-2xl font-serif font-semibold text-[#E8E0D0]/80 mb-4 max-sm:mb-3 italic" data-id="element-281">
            El Poder de La IA en Tus Manos.
          </motion.p>

          <motion.h2 variants={fadeUp} className="text-base md:text-xl text-[#A09880] mb-8 max-sm:mb-6 leading-relaxed max-w-2xl" data-id="element-282">
            Haz que la IA haga el trabajo duro por ti.
          </motion.h2>

          <motion.div variants={fadeUp} className="flex flex-col gap-3 mb-8 max-sm:mb-6 max-sm:items-center md:items-start" data-id="element-283">
            <p className="text-base max-sm:text-sm text-[#E8E0D0]" data-id="element-284">
              📘 Guía + 🎧 Audiolibro + 4 Bonos{' '}
              <span className="text-[#D4AF37] font-bold" data-id="element-285">GRATIS</span>
            </p>
            <div className="flex items-center gap-3 flex-wrap max-sm:justify-center" data-id="element-286">
              <span className="text-[#A09880] text-base line-through decoration-[#FF3B3B]/50" data-id="element-287">
                $254
              </span>
              <span className="bg-[#FF3B3B]/10 text-[#FF3B3B] border border-[#FF3B3B]/30 px-3 py-1 rounded-full text-xs font-bold uppercase" data-id="element-288">
                95% OFF
              </span>
            </div>
            <span className="text-3xl md:text-4xl font-black text-[#D4AF37] drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-289">
              Solo $12.97
            </span>
          </motion.div>

          <motion.button variants={fadeUp} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          document.getElementById('value-table')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="w-full max-w-[480px] bg-[#D4AF37] hover:bg-[#B8962E] text-[#0A0A0A] font-black text-lg md:text-xl py-5 max-sm:py-4 px-8 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.3)] hover:shadow-[0_0_50px_rgba(212,175,55,0.5)] mb-4 max-sm:mb-3 transition-all uppercase tracking-wide" data-id="element-290">
            ⚡ SÍ, QUIERO ACCESO INMEDIATO POR $12.97 →
          </motion.button>

          <motion.p variants={fadeUp} className="text-sm text-[#A09880] mb-6 max-sm:mb-5 max-w-[480px] text-center md:text-left leading-relaxed" data-id="element-291">
            ¿Por qué solo $12.97? Porque es un producto digital y no tenemos
            costos de impresión o envío. Te trasladamos ese ahorro a ti.
          </motion.p>

          <motion.div variants={fadeUp} className="flex flex-wrap justify-center md:justify-start gap-x-4 gap-y-2 text-xs md:text-sm font-semibold max-w-[480px]" data-id="element-292">
            <span className="text-[#A09880]" data-id="element-293">🔒 Pago 100% Seguro</span>
            <span className="text-[#A09880]" data-id="element-294">🚫 Sin Suscripciones Ocultas</span>
            <span className="text-[#A09880]" data-id="element-295">📥 Descarga Inmediata</span>
            <span className="text-[#A09880]" data-id="element-296">↩️ Garantía 30 Días</span>
            <span className="text-[#A09880]" data-id="element-297">
              💳 Visa · PayPal · Mastercard
            </span>
          </motion.div>
        </motion.div>

        {/* Right Content - 3D Mockup */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex justify-center items-center py-12 max-sm:py-4" data-id="element-298">
          <div className="relative" data-id="element-299">
            <div className="absolute inset-0 bg-[#D4AF37]/10 blur-[60px] rounded-full scale-90 pointer-events-none" data-id="element-300"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ifLHru3Ra84GKgQCEmaRWE/ChatGPT_Image_31_mar_2026,_03_33_11_p.m..png" alt="eBook IA al Rescate - Domina ChatGPT y Simplifica tu Vida en Minutos" className="relative z-10 w-full max-w-[520px] max-sm:max-w-[340px] rounded-xl drop-shadow-[0_20px_60px_rgba(212,175,55,0.15)] object-contain" loading="eager" decoding="async" data-id="element-301" />
          </div>
        </motion.div>
      </div>
    </section>;
}